<template>
  <div class="core-competencies">
    <div class="content-center">
      <div class="module-header">
        <div class="double-arrow"></div>
      </div>
      <FadeInBox>
        <div class="module-title">成为云企业，我们提供核心能力</div>
        <div class="module-body">
          <div class="module-body-left">
            <div class="title">云企业架构</div>
            <div class="tag">云企业总经理</div>
            <div class="department-container">
              <div class="department-item">市场部</div>
              <div class="department-item">采购部</div>
              <div class="department-item">财务部</div>
              <div class="department-item">综合部</div>
            </div>
          </div>
          <div class="module-body-right">
            <div class="title">平台赋能体系</div>
            <div class="tag">云管家</div>
            <div class="empowerment-container">
              <div class="empowerment-row">
                <div class="empowerment-item">解决方案</div>
                <div class="empowerment-item">服务生态</div>
                <div class="empowerment-item">商机雷达</div>
                <div class="empowerment-item">...</div>
              </div>
              <div class="empowerment-row">
                <div class="empowerment-item">供应链生态</div>
                <div class="empowerment-item">平台采购</div>
                <div class="empowerment-item">账期共享</div>
                <div class="empowerment-item">...</div>
              </div>
              <div class="empowerment-row">
                <div class="empowerment-item">账户管理</div>
                <div class="empowerment-item">收支管理</div>
                <div class="empowerment-item">税务筹划</div>
                <div class="empowerment-item">...</div>
              </div>
              <div class="empowerment-row">
                <div class="empowerment-item">生态经理</div>
                <div class="empowerment-item">电子签章</div>
                <div class="empowerment-item">法律援助</div>
                <div class="empowerment-item">...</div>
              </div>
            </div>
          </div>
        </div>
      </FadeInBox>
    </div>
  </div>
</template>

<script>
import FadeInBox from './FadeInBox.vue';

export default {
  components: { FadeInBox },
};
</script>

<style lang="less" scoped>
.core-competencies {
  padding: 64px 0;
  background-color: #fff;

  .content-center {
    .double-arrow {
      margin-bottom: 24px;
    }
    .module-body {
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .module-body-left,
      .module-body-right {
        height: 536px;
        padding-top: 40px;
        padding-bottom: 34px;
        background: linear-gradient(to bottom, #FAFCFF 0%, #F0F6FE 100%);
        border-radius: 4px;
        .title {
          font-family: @font-medium;
          font-size: 20px;
          color: #001B58;
          text-align: center;
          line-height: 28px;
        }
        .tag {
          margin-top: 24px;
          background-position: center;
          background-repeat: no-repeat;
          color: #fff;
          text-align: center;
          line-height: 44px;
        }
        .department-container,
        .empowerment-container {
          height: 342px;
          margin-top: 24px;
        }
      }
      .module-body-left {
        width: 361px;
        padding-left: 55px;
        padding-right: 55px;
        .tag {
          background-image: url('@/assets/img/cooperation/CoreCompetencies/left_tag_bg.png');
          position: relative;
          &::after {
            content: '';
            width: 436px;
            height: 12px;
            background-image: url('@/assets/img/cooperation/CoreCompetencies/line.png');
            background-size: 100% 100%;
            position: absolute;
            left: 235px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .department-container {
          padding: 32px 56px;
          background-color: #D4EBFF;
          border-radius: 6px;
          .department-item {
            height: 36px;
            border: 1px solid #034A9B;
            border-radius: 2px;
            color: #034A9B;
            font-size: 14px;
            text-align: center;
            line-height: 34px;
            position: relative;
            + .department-item {
              margin-top: 45px;
            }
            &::after {
              content: '';
              width: 80px;
              height: 80px;
              background-size: 100% 100%;
              position: absolute;
              right: -186px;
              top: 50%;
              transform: translateY(-50%);
            }
            &:nth-child(1)::after {
              background-image: url('@/assets/img/cooperation/CoreCompetencies/arrow1.png');
            }
            &:nth-child(2)::after {
              background-image: url('@/assets/img/cooperation/CoreCompetencies/arrow2.png');
            }
            &:nth-child(3)::after {
              background-image: url('@/assets/img/cooperation/CoreCompetencies/arrow3.png');
            }
            &:nth-child(4)::after {
              background-image: url('@/assets/img/cooperation/CoreCompetencies/arrow4.png');
            }
          }
        }
      }
      .module-body-right {
        width: 851px;
        padding-left: 50px;
        padding-right: 50px;
        .tag {
          background-image: url('@/assets/img/cooperation/CoreCompetencies/right_tag_bg.png');
        }
        .empowerment-container {
          padding: 16px 0;
          .empowerment-row {
            padding: 16px 45px;
            border-radius: 6px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            + .empowerment-row {
              margin-top: 13px;
            }
            .empowerment-item {
              width: 140px;
              height: 36px;
              border: 1px solid;
              border-radius: 2px;
              font-size: 14px;
              text-align: center;
              line-height: 34px;
            }

            &:nth-child(1) {
              background-color: #DCECFB;
              .empowerment-item {
                border-color: #005EFF;
                color: #005EFF;
              }
            }
            &:nth-child(2) {
              background-color: #FBDCDC;
              .empowerment-item {
                border-color: #FF4134;
                color: #FF4134;
              }
            }
            &:nth-child(3) {
              background-color: #FBEEDC;
              .empowerment-item {
                border-color: #FF8800;
                color: #FF8800;
              }
            }
            &:nth-child(4) {
              background-color: #DCFBF0;
              .empowerment-item {
                border-color: #039C41;
                color: #039C41;
              }
            }
          }
        }
      }
    }
  }
}
</style>
